/* eslint-disable @typescript-eslint/no-explicit-any */
import { Typography } from '@design-system/components/typography/typography';
import { SideModal } from '@design-system/components/modal/sideModal';
import { Button } from '@design-system/components/button/button';
import { ChallengesVM } from '../view-model/Challenges.viewModel';
import { ChallengeForm } from './ChallengeForm';
import { formWrapper } from './Challenges.view.css';
import { emptyDiscountsCol } from '../../promotions/view/Discounts.view.css';
import { Col, Row } from '@design-system/components/grid/grid';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { ChallengeElement } from './components/ChallengeElement';
import { SearchInput } from '@design-system/components/searchinput';
import { rgb } from '@design-system/tokens';
import * as styles from './Challenges.view.css';
import { ContentTable } from './components/common/ContentTable';
import { challengesHeader } from '../view-model/Challenges.mapper';
import { NeedHelpRow } from './components/NeedHelpRow';
export const ChallengesView = (p: ChallengesVM) => (
  <Col>
    {p.challengesCnt === 0 ? <EmptyChallenges {...p} /> : <Challenges {...p} />}
    <ChallengeFormModal {...p} />
  </Col>
);

const EmptyChallenges = (p: ChallengesVM) => (
  <Col className={emptyDiscountsCol}>
    <Col style={{ alignItems: 'center' }}>
      <Typography variant="headline" size="medium">
        Create a challenge
      </Typography>
      <Typography
        variant="bodyLarge"
        style={{ maxWidth: 330, color: rgb('B-60') }}
      >
        Start creating challenges that energize and inspire people today!
      </Typography>
      <Button
        leftIcon={faPlus}
        color="primaryTonal"
        variant="filled"
        onClick={() => p.dispatch('CreateChallenge')}
        testId="NewChallengeButton"
        style={{ maxHeight: 44, marginTop: 24 }}
      >
        New challenge
      </Button>
      <Row style={{ marginTop: 16 }}>
        <NeedHelpRow />
      </Row>
    </Col>
  </Col>
);

const Challenges = (p: ChallengesVM) => (
  <Col gap="xl">
    {p.ongoingChallengeVM ? (
      <ChallengeElement {...p.ongoingChallengeVM} />
    ) : null}
    <FinishedChallengesSection {...p} />
  </Col>
);

const FinishedChallengesSection = (p: ChallengesVM) => (
  <Row className={styles.challengesWrapper}>
    <Col gap="l">
      <Row>
        <Typography variant="title" size="large">
          All challenges
        </Typography>
      </Row>
      <Row>
        <SearchInput
          inputWrapperClassName={styles.searchWrapper}
          placeholder="Search by name"
          value={p.searchText}
          onChange={(e) => p.dispatch('Search', e.target.value)}
          onClear={() => p.dispatch('Search', '')}
        />
      </Row>
      <Col className={styles.challengesTable}>
        <ContentTable
          header={challengesHeader}
          rows={p.challengesList}
          {...p.sorting}
        />
      </Col>
    </Col>
  </Row>
);

const ChallengeFormModal = (p: ChallengesVM) => {
  return (
    <SideModal
      isOpen={p.modalMode.type !== 'none'}
      onClose={() => p.dispatch('CloseModal')}
      noSpacing
    >
      <div className={formWrapper}>
        {p.modalMode.type !== 'none' && (
          <ChallengeForm {...p.modalMode.value} mode={p.modalMode.type} />
        )}
      </div>
    </SideModal>
  );
};
